module.exports = __webpack_public_path__ + "static/media/JamesDietle.96d87cd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2019-speakers/JamesDietle.png
// module id = 840
// module chunks = 0